import {z} from 'zod';

import {addRatePairIssues} from './addRatePairIssues';
import {financingRateSchema} from './financingRateSchema';

/**
 * The monthly rate is always required. The interest rates are optional as a pair, which
 * `addRatePairIssues` enforces.
 */
export const leasingCellFormSchema = z
  .object({
    monthlyRateAmount: financingRateSchema,
    nominalRate: financingRateSchema.nullable(),
    apr: financingRateSchema.nullable(),
    setActive: z.boolean(),
  })
  .superRefine(addRatePairIssues);

export type LeasingCellFormValues = z.infer<typeof leasingCellFormSchema>;
